import { createContext, useContext } from 'react';

export interface RequestViralizeCourseOptions {
  readonly replayQuestionnaire?: boolean;
}

export interface ViralizeQualificationContextValue {
  requestViralizeCourse: (
    trigger?: HTMLElement | null,
    options?: RequestViralizeCourseOptions,
  ) => Promise<void>;
}

export const ViralizeQualificationContext =
  createContext<ViralizeQualificationContextValue | null>(null);

export function useViralizeQualification(): ViralizeQualificationContextValue {
  const value = useContext(ViralizeQualificationContext);
  if (!value) {
    throw new Error(
      'useViralizeQualification must be used within a ViralizeQualificationProvider.',
    );
  }
  return value;
}
